
import gsap from "gsap";

export default function initScrollCounter() {
  const wrapper = document.getElementById('scroll-progress-wrapper');
  const box = document.getElementById('scroll-progress');

  let currentValue = 0;
  let ticking = false;

  function getScrollPercent() {
    const doc = document.documentElement;
    const scrollTop = window.scrollY || doc.scrollTop || document.body.scrollTop;
    const scrollHeight = (document.body.scrollHeight || doc.scrollHeight) - window.innerHeight;

    if (scrollHeight <= 0) return 0;
    
    let progress = scrollTop / scrollHeight;
    if (progress < 0) progress = 0;
    if (progress > 1) progress = 1;


    return Math.ceil(progress * 100);

  }

  function animateTo(newValue) {
    if (newValue === currentValue) return;

    const direction = newValue > currentValue ? 1 : -1; // 1 – вниз, -1 – вверх
    const oldEl = wrapper.querySelector('.scroll-progress__value--current') ||
                  wrapper.querySelector('.scroll-progress__value');

    if (!oldEl) return;

    oldEl.classList.remove('scroll-progress__value--current');
    oldEl.classList.add('scroll-progress__value--old');

    const newEl = document.createElement('div');
    newEl.className = 'scroll-progress__value scroll-progress__value--current';
    newEl.textContent = newValue;     // только число, без процента
    wrapper.appendChild(newEl);

    const fromYNew = direction === 1 ? '100%' : '-100%';
    const toYNew   = '0%';
    const fromYOld = '0%';
    const toYOld   = direction === 1 ? '-100%' : '100%';

    const tl = gsap.timeline({
      defaults: { duration: 0.25, ease: 'power2.out' },
      onComplete: () => {
        if (oldEl && oldEl.parentNode === wrapper) {
          oldEl.remove();
        }
      }
    });

    tl.fromTo(newEl,
      { y: fromYNew, opacity: 0 },
      { y: toYNew, opacity: 1 },
      0
    ).to(oldEl,
      { y: toYOld, opacity: 0 },
      0
    );

    // лёгкий "пульс" всего блока
    gsap.fromTo(box,
      { scale: 0.96 },
      { scale: 1, duration: 0.22, ease: 'power2.out' }
    );

    currentValue = newValue;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        const percent = getScrollPercent();
        animateTo(percent);
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  // начальное значение
  animateTo(getScrollPercent());
}